import React, { createRef, useState, useEffect } from 'react';
import "./newcafe.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { cafeInputs } from "../../formSource";
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import Dropzone from 'react-dropzone';
// ── Food & Drink ──────────────────────────────────────────────────────────────
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import BrunchDiningIcon from '@mui/icons-material/BrunchDining';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import KitchenIcon from '@mui/icons-material/Kitchen';
import GrassIcon from '@mui/icons-material/Grass';
import NoMealsIcon from '@mui/icons-material/NoMeals';
import SpaIcon from '@mui/icons-material/Spa';
import EmojiFoodBeverageIcon from '@mui/icons-material/EmojiFoodBeverage';
import SetMealIcon from '@mui/icons-material/SetMeal';
import RamenDiningIcon from '@mui/icons-material/RamenDining';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import IcecreamIcon from '@mui/icons-material/Icecream';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import TapasIcon from '@mui/icons-material/Tapas';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
// ── Amenities & Comfort ───────────────────────────────────────────────────────
import WifiIcon from '@mui/icons-material/Wifi';
import TvIcon from '@mui/icons-material/Tv';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import DeckIcon from '@mui/icons-material/Deck';
import WavesIcon from '@mui/icons-material/Waves';
import LandscapeIcon from '@mui/icons-material/Landscape';
import PoolIcon from '@mui/icons-material/Pool';
import HotTubIcon from '@mui/icons-material/HotTub';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import CabinIcon from '@mui/icons-material/Cabin';
import BalconyIcon from '@mui/icons-material/Balcony';
import YardIcon from '@mui/icons-material/Yard';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
// ── Services ──────────────────────────────────────────────────────────────────
import RoomServiceIcon from '@mui/icons-material/RoomService';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import LocalPlayIcon from '@mui/icons-material/LocalPlay';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import IronIcon from '@mui/icons-material/Iron';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
// ── Transport & Access ────────────────────────────────────────────────────────
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import AccessibleIcon from '@mui/icons-material/Accessible';
import SmokeFreeIcon from '@mui/icons-material/SmokeFree';
import SmokingRoomsIcon from '@mui/icons-material/SmokingRooms';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
// ── Entertainment ─────────────────────────────────────────────────────────────
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import PianoIcon from '@mui/icons-material/Piano';
import CasinoIcon from '@mui/icons-material/Casino';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import FestivalIcon from '@mui/icons-material/Festival';
import CelebrationIcon from '@mui/icons-material/Celebration';
// ── People & Family ───────────────────────────────────────────────────────────
import ChildCareIcon from '@mui/icons-material/ChildCare';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import PetsIcon from '@mui/icons-material/Pets';
import ElderlyIcon from '@mui/icons-material/Elderly';
import GroupsIcon from '@mui/icons-material/Groups';
// ── Hotel Specific ────────────────────────────────────────────────────────────
import HotelIcon from '@mui/icons-material/Hotel';
import KingBedIcon from '@mui/icons-material/KingBed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import ShowerIcon from '@mui/icons-material/Shower';
import ElevatorIcon from '@mui/icons-material/Elevator';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LuggageIcon from '@mui/icons-material/Luggage';
import NightlightIcon from '@mui/icons-material/Nightlight';
import SecurityIcon from '@mui/icons-material/Security';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
// ── General ───────────────────────────────────────────────────────────────────
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import PublicIcon from '@mui/icons-material/Public';
import Brightness3Icon from '@mui/icons-material/Brightness3';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SearchIcon from '@mui/icons-material/Search';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import PowerIcon from '@mui/icons-material/Power';
import LaptopIcon from '@mui/icons-material/Laptop';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PrintIcon from '@mui/icons-material/Print';
import RoofingIcon from '@mui/icons-material/Roofing';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import LocalDrinkIcon from '@mui/icons-material/LocalDrink';
import CakeIcon from '@mui/icons-material/Cake';
import RiceBowlIcon from '@mui/icons-material/RiceBowl';
import GrainIcon from '@mui/icons-material/Grain';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import ToysIcon from '@mui/icons-material/Toys';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ExtensionIcon from '@mui/icons-material/Extension';
import FavoriteIcon from '@mui/icons-material/Favorite';

const CITIES = [
  'Casablanca', 'Rabat', 'Meknès', 'Marrakech', 'Essaouira', 'Fès',
  'Tanger', 'Agadir', 'Al Hoceïma', 'Chefchaouen', 'Nador', 'Kénitra',
  'Asilah', 'Tétouan', 'Ifrane', 'Dakhla',
];

const normalizeCity = (city) =>
  city.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const SERVICE_CATEGORIES = [
  { id: 'all', label: 'Tous les services', icon: null },
  { id: 'tech', label: 'Wi‑Fi & Travail', icon: <WifiIcon /> },
  { id: 'food', label: 'Nourriture & Boissons', icon: <RestaurantIcon /> },
  { id: 'service', label: 'Services au client', icon: <RoomServiceIcon /> },
  { id: 'facilities', label: 'Équipements & Espace', icon: <DeckIcon /> },
  { id: 'ambiance', label: 'Ambiance & Divertissement', icon: <MusicNoteIcon /> },
  { id: 'family', label: 'Famille & Accessibilité', icon: <FamilyRestroomIcon /> },
  { id: 'seasonal', label: 'Ramadan & Saisonnier', icon: <NightlightIcon /> },
];

const SERVICES = [
  // ── TECH & TRAVAIL ───────────────────────────────────────────────
  { value: "wifi", label: "Wi‑Fi gratuit", icon: <WifiIcon />, category: "tech", popular: true },
  { value: "wifi_fast", label: "Wi‑Fi haut débit", icon: <NetworkWifiIcon />, category: "tech", popular: true },
  { value: "power", label: "Prises électriques", icon: <PowerIcon />, category: "tech", popular: true },
  { value: "work_space", label: "Espace de travail", icon: <LaptopIcon />, category: "tech", popular: true },
  { value: "quiet", label: "Espace calme", icon: <VolumeOffIcon />, category: "tech" },
  { value: "printer", label: "Imprimante", icon: <PrintIcon />, category: "tech" },

  // ── NOURRITURE & BOISSONS ────────────────────────────────────────
  { value: "breakfast", label: "Petit‑déjeuner", icon: <FreeBreakfastIcon />, category: "food", popular: true },
  { value: "brunch", label: "Brunch", icon: <BrunchDiningIcon />, category: "food", popular: true },
  { value: "lunch", label: "Déjeuner", icon: <LunchDiningIcon />, category: "food" },
  { value: "dinner", label: "Dîner", icon: <DinnerDiningIcon />, category: "food" },
  { value: "moroccan_tea", label: "Thé marocain", icon: <EmojiFoodBeverageIcon />, category: "food", popular: true },
  { value: "specialty_coffee", label: "Café de spécialité", icon: <LocalCafeIcon />, category: "food", popular: true },
  { value: "fresh_juice", label: "Jus frais", icon: <LocalDrinkIcon />, category: "food", popular: true },
  { value: "smoothies", label: "Smoothies", icon: <LocalDrinkIcon />, category: "food" },
  { value: "pastries", label: "Pâtisseries", icon: <CakeIcon />, category: "food" },
  { value: "bakery", label: "Boulangerie", icon: <BakeryDiningIcon />, category: "food" },
  { value: "ice_cream", label: "Glaces & desserts", icon: <IcecreamIcon />, category: "food" },
  { value: "tapas", label: "Tapas / Apéro", icon: <TapasIcon />, category: "food" },
  { value: "pizza", label: "Pizza", icon: <LocalPizzaIcon />, category: "food" },
  { value: "burger", label: "Burgers", icon: <LunchDiningIcon />, category: "food" },
  { value: "sushi", label: "Sushi", icon: <SetMealIcon />, category: "food", popular: true },
  { value: "asian_cuisine", label: "Cuisine asiatique", icon: <RamenDiningIcon />, category: "food", popular: true },
  { value: "grill", label: "Grillades", icon: <OutdoorGrillIcon />, category: "food", popular: true },
  { value: "moroccan_cuisine", label: "Cuisine marocaine", icon: <RestaurantMenuIcon />, category: "food", popular: true },
  { value: "seafood", label: "Fruits de mer", icon: <SetMealIcon />, category: "food" },
  { value: "pasta", label: "Pâtes", icon: <RiceBowlIcon />, category: "food" },
  { value: "buffet", label: "Buffet / Show cooking", icon: <RestaurantMenuIcon />, category: "food" },
  { value: "cooking_class", label: "Ateliers cuisine", icon: <KitchenIcon />, category: "food" },
  { value: "vegan", label: "Options véganes", icon: <SpaIcon />, category: "food" },
  { value: "vegetarian", label: "Options végétariennes", icon: <GrassIcon />, category: "food" },
  { value: "gluten_free", label: "Sans gluten", icon: <GrainIcon />, category: "food" },
  { value: "lactose_free", label: "Sans lactose", icon: <NoMealsIcon />, category: "food" },
  { value: "halal", label: "Halal", icon: <RestaurantIcon />, category: "food" },
  { value: "kids_menu", label: "Menu enfants", icon: <ChildFriendlyIcon />, category: "food", popular: true },

  // ── SERVICES ─────────────────────────────────────────────────────
  { value: "reservation", label: "Réservation", icon: <EventAvailableIcon />, category: "service", popular: true },
  { value: "table_service", label: "Service à table", icon: <RoomServiceIcon />, category: "service" },
  { value: "takeaway", label: "Vente à emporter", icon: <ShoppingBagIcon />, category: "service", popular: true },
  { value: "delivery", label: "Livraison", icon: <DeliveryDiningIcon />, category: "service", popular: true },
  { value: "online_order", label: "Commande en ligne", icon: <PhoneIphoneIcon />, category: "service" },
  { value: "card", label: "Paiement par carte", icon: <CreditCardIcon />, category: "service" },
  { value: "private_room", label: "Salle privatisable", icon: <MeetingRoomIcon />, category: "service" },
  { value: "meeting_room", label: "Salle de réunion", icon: <BusinessCenterIcon />, category: "service" },
  { value: "birthday", label: "Anniversaires", icon: <CakeIcon />, category: "service", popular: true },
  { value: "events", label: "Événements privés", icon: <CelebrationIcon />, category: "service" },
  { value: "weddings", label: "Mariages / Fiançailles", icon: <FavoriteIcon />, category: "service" },

  // ── ÉQUIPEMENTS ──────────────────────────────────────────────────
  { value: "terrace", label: "Terrasse", icon: <DeckIcon />, category: "facilities", popular: true },
  { value: "ac", label: "Climatisation", icon: <AcUnitIcon />, category: "facilities" },
  { value: "parking", label: "Parking", icon: <LocalParkingIcon />, category: "facilities", popular: true },
  { value: "valet", label: "Voiturier", icon: <DriveEtaIcon />, category: "facilities" },
  { value: "rooftop", label: "Rooftop", icon: <RoofingIcon />, category: "facilities", popular: true },
  { value: "non_smoking", label: "Zone non-fumeur", icon: <SmokeFreeIcon />, category: "facilities" },

  // ── AMBIANCE & LOISIRS ───────────────────────────────────────────
  { value: "live_music", label: "Musique live", icon: <MusicNoteIcon />, category: "ambiance" },
  { value: "piano_jazz", label: "Soirées piano / jazz", icon: <PianoIcon />, category: "ambiance" },
  { value: "sports_tv", label: "Diffusion sport", icon: <SportsSoccerIcon />, category: "ambiance", popular: true },
  { value: "bein_sport", label: "BeIN Sports", icon: <TvIcon />, category: "ambiance" },
  { value: "board_games", label: "Jeux de société", icon: <ExtensionIcon />, category: "ambiance" },
  { value: "cosy", label: "Ambiance cosy", icon: <FireplaceIcon />, category: "ambiance" },
  { value: "sea_view", label: "Vue mer", icon: <WavesIcon />, category: "ambiance" },
  { value: "panoramic_view", label: "Vue panoramique", icon: <LandscapeIcon />, category: "ambiance" },
  { value: "sunset_view", label: "Vue coucher de soleil", icon: <WbTwilightIcon />, category: "ambiance" },
  { value: "beach", label: "Accès plage", icon: <BeachAccessIcon />, category: "ambiance" },
  { value: "medina_view", label: "Vue médina", icon: <LandscapeIcon />, category: "ambiance" },

  // ── FAMILLE & ACCÈS ──────────────────────────────────────────────
  { value: "kids_area", label: "Espace enfants", icon: <ChildFriendlyIcon />, category: "family", popular: true },
  { value: "kids_play", label: "Jeux pour enfants", icon: <ToysIcon />, category: "family" },
  { value: "high_chair", label: "Chaises hautes", icon: <ChildCareIcon />, category: "family" },
  { value: "family_space", label: "Espace familial", icon: <FamilyRestroomIcon />, category: "family" },
  { value: "groups", label: "Groupes acceptés", icon: <GroupsIcon />, category: "family" },
  { value: "wheelchair", label: "Accès PMR", icon: <AccessibleIcon />, category: "family" },
  { value: "pets", label: "Animaux acceptés", icon: <PetsIcon />, category: "family" },
  { value: "prayer_room", label: "Espace de prière", icon: <MenuBookIcon />, category: "family" },

  // ── SAISONNIER ───────────────────────────────────────────────────
  { value: "ftour", label: "Ftour Ramadan 🌙", icon: <BedtimeIcon />, category: "seasonal", ramadan: true },
  { value: "chronos", label: "Chronos Ramadan", icon: <NightlightIcon />, category: "seasonal", ramadan: true },
];

const NewCafe = () => {
  const [info, setInfo] = useState({});
  const [services, setServices] = useState([]);
  const [logoUrl, setLogoUrl] = useState('');
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [bannerUrl, setBannerUrl] = useState('');
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const [photosUrls, setPhotosUrls] = useState([]);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [socials, setSocials] = useState({});
  const [mapEmbedUrl, setMapEmbedUrl] = useState('');
  const [menuLink, setMenuLink] = useState('');
  const [customType, setCustomType] = useState('');
  const [logoPreview, setLogoPreview] = useState(null);
  const [bannerPreview, setBannerPreview] = useState(null);
  const [featured, setFeatured] = useState(false);
  const [customServices, setCustomServices] = useState([]);
  const [newServiceLabel, setNewServiceLabel] = useState('');
  const [newServiceIcon, setNewServiceIcon] = useState({ type: 'mui', value: 'Star' });
  const [showPicker, setShowPicker] = useState(false);
  const [iconSearch, setIconSearch] = useState('');
  const [serviceSearch, setServiceSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredServices = SERVICES.filter((s) => {
    const matchesCategory = activeCategory === 'all' || s.category === activeCategory;
    const matchesSearch = s.label.toLowerCase().includes(serviceSearch.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // ── MUI icon registry (name → component) ──────────────────────────────────
  const MUI_ICONS = {
    // Food
    'LocalCafe': <LocalCafeIcon />,
    'BrunchDining': <BrunchDiningIcon />,
    'RestaurantMenu': <RestaurantMenuIcon />,
    'Restaurant': <RestaurantIcon />,
    'Kitchen': <KitchenIcon />,
    'Grass': <GrassIcon />,
    'NoMeals': <NoMealsIcon />,
    'Spa': <SpaIcon />,
    'EmojiFoodBeverage': <EmojiFoodBeverageIcon />,
    'SetMeal': <SetMealIcon />,
    'RamenDining': <RamenDiningIcon />,
    'LunchDining': <LunchDiningIcon />,
    'DinnerDining': <DinnerDiningIcon />,
    'Icecream': <IcecreamIcon />,
    'LocalBar': <LocalBarIcon />,
    'LocalPizza': <LocalPizzaIcon />,
    'BakeryDining': <BakeryDiningIcon />,
    'Tapas': <TapasIcon />,
    'FreeBreakfast': <FreeBreakfastIcon />,
    'Cake': <CakeIcon />,
    'LocalDrink': <LocalDrinkIcon />,
    'RiceBowl': <RiceBowlIcon />,
    'Eco': <SpaIcon />,
    'Grain': <GrainIcon />,
    // Amenities
    'Wifi': <WifiIcon />,
    'NetworkWifi': <NetworkWifiIcon />,
    'Power': <PowerIcon />,
    'Laptop': <LaptopIcon />,
    'VolumeOff': <VolumeOffIcon />,
    'Print': <PrintIcon />,
    'Tv': <TvIcon />,
    'AcUnit': <AcUnitIcon />,
    'Fireplace': <FireplaceIcon />,
    'Deck': <DeckIcon />,
    'Waves': <WavesIcon />,
    'Landscape': <LandscapeIcon />,
    'Pool': <PoolIcon />,
    'HotTub': <HotTubIcon />,
    'BeachAccess': <BeachAccessIcon />,
    'Cabin': <CabinIcon />,
    'Balcony': <BalconyIcon />,
    'Yard': <YardIcon />,
    'OutdoorGrill': <OutdoorGrillIcon />,
    'Roofing': <RoofingIcon />,
    'WbTwilight': <WbTwilightIcon />,
    // Services
    'RoomService': <RoomServiceIcon />,
    'EventAvailable': <EventAvailableIcon />,
    'ShoppingBag': <ShoppingBagIcon />,
    'CreditCard': <CreditCardIcon />,
    'MeetingRoom': <MeetingRoomIcon />,
    'LocalPlay': <LocalPlayIcon />,
    'SupportAgent': <SupportAgentIcon />,
    'CleaningServices': <CleaningServicesIcon />,
    'Iron': <IronIcon />,
    'LocalLaundryService': <LocalLaundryServiceIcon />,
    'BusinessCenter': <BusinessCenterIcon />,
    'FitnessCenter': <FitnessCenterIcon />,
    'SelfImprovement': <SelfImprovementIcon />,
    'DeliveryDining': <DeliveryDiningIcon />,
    'PhoneIphone': <PhoneIphoneIcon />,
    // Transport
    'LocalParking': <LocalParkingIcon />,
    'DriveEta': <DriveEtaIcon />,
    'Accessible': <AccessibleIcon />,
    'SmokeFree': <SmokeFreeIcon />,
    'SmokingRooms': <SmokingRoomsIcon />,
    'DirectionsBus': <DirectionsBusIcon />,
    'ElectricCar': <ElectricCarIcon />,
    'TwoWheeler': <TwoWheelerIcon />,
    'AirportShuttle': <AirportShuttleIcon />,
    // Entertainment
    'MusicNote': <MusicNoteIcon />,
    'Piano': <PianoIcon />,
    'Casino': <CasinoIcon />,
    'SportsBar': <SportsBarIcon />,
    'SportsSoccer': <SportsSoccerIcon />,
    'GolfCourse': <GolfCourseIcon />,
    'Festival': <FestivalIcon />,
    'Celebration': <CelebrationIcon />,
    'Favorite': <FavoriteIcon />,
    'Extension': <ExtensionIcon />,
    // Family
    'ChildCare': <ChildCareIcon />,
    'ChildFriendly': <ChildFriendlyIcon />,
    'FamilyRestroom': <FamilyRestroomIcon />,
    'Pets': <PetsIcon />,
    'Elderly': <ElderlyIcon />,
    'Groups': <GroupsIcon />,
    'Toys': <ToysIcon />,
    'MenuBook': <MenuBookIcon />,
    // Hotel
    'Hotel': <HotelIcon />,
    'KingBed': <KingBedIcon />,
    'Bathtub': <BathtubIcon />,
    'Shower': <ShowerIcon />,
    'Elevator': <ElevatorIcon />,
    'VpnKey': <VpnKeyIcon />,
    'Luggage': <LuggageIcon />,
    'Nightlight': <NightlightIcon />,
    'Security': <SecurityIcon />,
    'CameraAlt': <CameraAltIcon />,
    // General
    'Star': <StarIcon />,
    'Verified': <VerifiedIcon />,
    'LocalOffer': <LocalOfferIcon />,
    'Public': <PublicIcon />,
    'Brightness3': <BedtimeIcon />,
  };

  const QUICK_EMOJIS = [
    '⭐', '🍕', '🍔', '🥗', '🍜', '🍣', '🥩', '🍰', '☕', '🧃',
    '🍺', '🥂', '🍷', '🧁', '🥐', '🫕', '🍱', '🌮', '🥘', '🍝',
    '🎭', '🎵', '🎮', '📺', '🎪', '🌿', '🌊', '🏔️', '🌅', '🌙',
    '🚗', '🛵', '🚲', '✈️', '🗺️', '📍', '🔑', '💳', '📶', '🔒',
    '👶', '👴', '🐕', '♿', '🚭', '🅿️', '❄️', '🔥', '💡', '🌟',
    '💎', '🏆', '🎯', '✅', '🆕', '🔝', '💯', '🎁', '🛎️', '🌙',
  ];

  const filteredMuiIcons = Object.entries(MUI_ICONS).filter(([name]) =>
    name.toLowerCase().includes(iconSearch.toLowerCase())
  );

  const renderSelectedIcon = () => (
    <span style={{ display: 'flex', alignItems: 'center', fontSize: 20 }}>
      {MUI_ICONS[newServiceIcon.value] || <StarIcon />}
    </span>
  );

  const renderCustomIcon = (icon) => MUI_ICONS[icon.value] || <StarIcon />;

  const addCustomService = () => {
    const label = newServiceLabel.trim();
    if (!label) return;
    const iconName = newServiceIcon.value;
    const value = `custom_${Date.now()}_${label}|||mui:${iconName}`;
    setCustomServices((prev) => [...prev, { value, label, icon: { type: 'mui', value: iconName } }]);
    setServices((prev) => [...prev, value]);
    setNewServiceLabel('');
    setNewServiceIcon({ type: 'mui', value: 'Star' });
    setIconSearch('');
    setShowPicker(false);
  };

  const removeCustomService = (value) => {
    setCustomServices(prev => prev.filter(s => s.value !== value));
    setServices(prev => prev.filter(s => s !== value));
  };

  const dropzoneRef = createRef();
  const navigate = useNavigate();

  const handleChange = (e) =>
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));

  const handleSocialsChange = (e) =>
    setSocials((prev) => ({ ...prev, [e.target.id]: e.target.value }));

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setServices((prev) =>
      checked ? [...prev, value] : prev.filter((s) => s !== value)
    );
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLogoPreview(URL.createObjectURL(file));
    setUploadingLogo(true);
    const fd = new FormData();
    fd.append('image', file);
    try {
      const res = await axios.post('https://api.moroccool.com/api/upload/image', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setLogoUrl(res.data.imageUrl + '?t=' + Date.now());
    } catch (err) { console.error(err); }
    finally { setUploadingLogo(false); }
  };

  const handleBannerUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setBannerPreview(URL.createObjectURL(file));
    setUploadingBanner(true);
    const fd = new FormData();
    fd.append('image', file);
    try {
      const res = await axios.post('https://api.moroccool.com/api/upload/image', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setBannerUrl(res.data.imageUrl + '?t=' + Date.now());
    } catch (err) { console.error(err); }
    finally { setUploadingBanner(false); }
  };

  const handlePhotosUpload = async (files) => {
    if (!files.length) return;
    setUploadingPhotos(true);
    try {
      for (const file of files) {
        const fd = new FormData();
        fd.append('image', file);
        const res = await axios.post('https://api.moroccool.com/api/upload/image', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setPhotosUrls((prev) => [...prev, res.data.imageUrl]);
      }
    } catch (err) { console.error(err); }
    finally { setUploadingPhotos(false); }
  };

  const removePhoto = (url) =>
    setPhotosUrls((prev) => prev.filter((p) => p !== url));

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      const newCafe = {
        ...info,
        services,
        logo: logoUrl,
        banner: bannerUrl,
        photos: photosUrls,
        socials,
        maps: mapEmbedUrl,
        menu: [menuLink],
        facebook: socials.facebook || '',
        instagram: socials.instagram || '',
        twitter: socials.x || '',
        tiktok: socials.tiktok || '',
        email: socials.email || '',
        website: socials.website || '',
        type: info.type === 'Autre' ? customType : info.type,
        featured,
      };
      await axios.post('https://api.moroccool.com/api/cafes', newCafe);
      navigate('/cafes');
    } catch (err) { console.error(err); }
  };

  return (
    <div className="ncf-studio">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div className="ncf-main">
        <Navbar />

        {/* ── HEADER ── */}
        <header className="ncf-header">
          <p className="ncf-header-eyebrow">Moroccool Dashboard</p>
          <h1 className="ncf-header-title">
            <strong>New</strong> Café or Restaurant
          </h1>
        </header>

        <div className="ncf-content">
          <form className="ncf-form" onSubmit={handleClick}>

            {/* ─── 01 · MEDIA ─────────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">01</span>
                  <h2 className="ncf-section-title">Visual Identity</h2>
                  <p className="ncf-section-desc">Logo, banner & gallery</p>
                </div>

                <div className="ncf-section-body">
                  {/* Logo + Banner */}
                  <div className="ncf-upload-row">
                    {/* LOGO */}
                    <div className="ncf-upload-card">
                      <label className="ncf-label">Logo</label>
                      {logoPreview || logoUrl ? (
                        <div className="ncf-preview-wrap">
                          <img src={logoPreview || logoUrl} alt="logo" className="ncf-preview-logo" />
                          <button type="button" className="ncf-remove-btn"
                            onClick={() => { setLogoUrl(''); setLogoPreview(null); }}>
                            <CloseIcon />
                          </button>
                        </div>
                      ) : (
                        <label className="ncf-upload-zone" htmlFor="logo-input">
                          <input type="file" accept="image/*" id="logo-input" onChange={handleLogoUpload} />
                          <CloudUploadOutlinedIcon className="ncf-upload-icon" />
                          <span className="ncf-upload-text">Upload logo</span>
                          <span className="ncf-upload-sub">PNG, JPG · max 5 MB</span>
                        </label>
                      )}
                      {uploadingLogo && (
                        <div className="ncf-progress">
                          <div className="ncf-progress-bar" />
                          Uploading…
                        </div>
                      )}
                    </div>

                    {/* BANNER */}
                    <div className="ncf-upload-card">
                      <label className="ncf-label">Banner</label>
                      {bannerPreview || bannerUrl ? (
                        <div className="ncf-banner-wrap">
                          <img src={bannerPreview || bannerUrl} alt="banner" className="ncf-preview-banner" />
                          <button type="button" className="ncf-remove-btn"
                            onClick={() => { setBannerUrl(''); setBannerPreview(null); }}>
                            <CloseIcon />
                          </button>
                        </div>
                      ) : (
                        <label className="ncf-upload-zone" htmlFor="banner-input">
                          <input type="file" accept="image/*" id="banner-input" onChange={handleBannerUpload} />
                          <CloudUploadOutlinedIcon className="ncf-upload-icon" />
                          <span className="ncf-upload-text">Upload banner</span>
                          <span className="ncf-upload-sub">Recommended 1440 × 480 px</span>
                        </label>
                      )}
                      {uploadingBanner && (
                        <div className="ncf-progress">
                          <div className="ncf-progress-bar" />
                          Uploading…
                        </div>
                      )}
                    </div>
                  </div>

                  {/* GALLERY */}
                  <div className="ncf-field" style={{ marginTop: 24 }}>
                    <label className="ncf-label">Gallery</label>
                    <Dropzone
                      ref={dropzoneRef}
                      onDrop={handlePhotosUpload}
                      multiple
                      accept={{ 'image/*': [] }}
                      noClick
                      noKeyboard
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()} className="ncf-dropzone"
                          onClick={() => dropzoneRef.current?.open()}>
                          <input {...getInputProps()} />
                          <CloudUploadOutlinedIcon className="ncf-dropzone-icon" />
                          <p className="ncf-dropzone-title">Drop images or click to browse</p>
                          <p className="ncf-dropzone-sub">Upload multiple photos for the gallery</p>
                        </div>
                      )}
                    </Dropzone>

                    {uploadingPhotos && (
                      <div className="ncf-progress">
                        <div className="ncf-progress-bar" />
                        Uploading photos…
                      </div>
                    )}

                    {photosUrls.length > 0 && (
                      <div className="ncf-gallery">
                        {photosUrls.map((url, i) => (
                          <div key={`${url}-${i}`} className="ncf-gallery-item">
                            <img src={url} alt={`photo ${i + 1}`} className="ncf-gallery-img" />
                            <button type="button" className="ncf-remove-btn" onClick={() => removePhoto(url)}>
                              <CloseIcon />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 02 · INFO ──────────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">02</span>
                  <h2 className="ncf-section-title">General Info</h2>
                  <p className="ncf-section-desc">Name, city, type & description</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-input-grid">
                    {cafeInputs.map((input) => {
                      if (input.id === 'city') {
                        return (
                          <div className="ncf-field" key={input.id}>
                            <label className="ncf-label">{input.label}</label>
                            <select className="ncf-select" id="city"
                              value={info.city || ''} onChange={handleChange}>
                              <option value="">Select city</option>
                              {CITIES.map((c) => (
                                <option key={c} value={normalizeCity(c)}>{c}</option>
                              ))}
                            </select>
                          </div>
                        );
                      }
                      if (input.id === 'type') {
                        return (
                          <div className="ncf-field" key={input.id}>
                            <label className="ncf-label">{input.label}</label>
                            <select className="ncf-select" id="type"
                              value={info.type || ''}
                              onChange={(e) => { handleChange(e); if (e.target.value !== 'Autre') setCustomType(''); }}>
                              <option value="">Select type</option>
                              <option value="Café">Café</option>
                              <option value="Restaurant">Restaurant</option>
                              <option value="Café / Restaurant">Café / Restaurant</option>
                              <option value="Autre">Autre</option>
                            </select>
                            {info.type === 'Autre' && (
                              <input className="ncf-input" style={{ marginTop: 8 }}
                                type="text" placeholder="Précisez le type…"
                                value={customType} onChange={(e) => setCustomType(e.target.value)} />
                            )}
                          </div>
                        );
                      }
                      return (
                        <div className="ncf-field" key={input.id}>
                          <label className="ncf-label">{input.label}</label>
                          <input className="ncf-input" type={input.type}
                            placeholder={input.placeholder} id={input.id}
                            value={info[input.id] || ''} onChange={handleChange} />
                        </div>
                      );
                    })}
                  </div>

                  <div className="ncf-field" style={{ marginTop: 20 }}>
                    <label className="ncf-label">Description</label>
                    <textarea className="ncf-textarea" id="description"
                      placeholder="Describe the atmosphere, signature dishes, what makes this place special…"
                      onChange={handleChange} />
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 03 · LOCATION ──────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">03</span>
                  <h2 className="ncf-section-title">Location</h2>
                  <p className="ncf-section-desc">Google Maps embed</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-field">
                    <label className="ncf-label">Maps Embed URL</label>
                    <input className="ncf-input" type="text"
                      placeholder="https://www.google.com/maps/embed?pb=…"
                      value={mapEmbedUrl} onChange={(e) => setMapEmbedUrl(e.target.value)} />
                    <span className="ncf-helper">Paste the iframe src from Google Maps → Share → Embed</span>
                  </div>
                  {mapEmbedUrl && (
                    <div className="ncf-iframe-wrap">
                      <iframe src={mapEmbedUrl} allowFullScreen loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade" title="Map" />
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* ─── 04 · MENU ──────────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">04</span>
                  <h2 className="ncf-section-title">Digital Menu</h2>
                  <p className="ncf-section-desc">PDF or flipbook link</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-field">
                    <label className="ncf-label">Menu URL</label>
                    <input className="ncf-input" type="text"
                      placeholder="https://heyzine.com/flip-book/…"
                      value={menuLink} onChange={(e) => setMenuLink(e.target.value)} />
                  </div>
                  {menuLink && (
                    <div className="ncf-iframe-wrap ncf-iframe-wrap--menu">
                      <iframe src={menuLink} title="Menu" />
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* ─── 05 · SOCIALS ───────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">05</span>
                  <h2 className="ncf-section-title">Social & Contact</h2>
                  <p className="ncf-section-desc">Links & email</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-social-grid">
                    {[
                      { id: 'facebook', placeholder: 'Facebook URL', icon: <FacebookIcon className="ncf-social-icon ncf-social-icon--fb" /> },
                      { id: 'instagram', placeholder: 'Instagram URL', icon: <InstagramIcon className="ncf-social-icon ncf-social-icon--ig" /> },
                      { id: 'x', placeholder: 'Twitter (X) URL', icon: <TwitterIcon className="ncf-social-icon ncf-social-icon--tw" /> },
                      { id: 'website', placeholder: 'Website URL', icon: <PublicIcon className="ncf-social-icon ncf-social-icon--web" /> },
                      { id: 'email', placeholder: 'Contact Email', icon: <span className="ncf-social-icon ncf-social-icon--em">📧</span>, type: 'email' },
                      { id: 'tiktok', placeholder: 'TikTok URL', icon: <span className="ncf-social-icon ncf-social-icon--tt">🎵</span> },
                    ].map(({ id, placeholder, icon, type }) => (
                      <div className="ncf-social-row" key={id}>
                        {icon}
                        <input className="ncf-social-input" id={id} type={type || 'text'}
                          placeholder={placeholder} onChange={handleSocialsChange} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 06 · SERVICES ──────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">06</span>
                  <h2 className="ncf-section-title">Services & Amenities</h2>
                  <p className="ncf-section-desc">Select all that apply</p>
                </div>

                <div className="ncf-section-body">

                  {/* ── FILTER PANEL ─────────────────────────────────────── */}
                  <div className="ncf-services-filter">

                    {/* Head row: title + stats + clear */}
                    <div className="ncf-services-filter-head">
                      <div className="ncf-services-filter-title">
                        Filtres
                      </div>

                      <div className="ncf-services-filter-stats">
                        <span>
                          <strong>{filteredServices.length}</strong> résultat{filteredServices.length > 1 ? 's' : ''}
                        </span>
                        {(services.length > 0 || serviceSearch || activeCategory !== 'all') && (
                          <button
                            type="button"
                            className="ncf-services-clear ncf-services-clear--ghost"
                            onClick={() => {
                              setServices([]);
                              setServiceSearch('');
                              setActiveCategory('all');
                            }}
                          >
                            <CloseIcon />
                            Réinitialiser
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Search bar */}
                    <div className="ncf-services-search">
                      <SearchIcon className="ncf-services-search-icon" />
                      <input
                        type="text"
                        placeholder="Rechercher un service…"
                        value={serviceSearch}
                        onChange={(e) => setServiceSearch(e.target.value)}
                      />
                      {serviceSearch && (
                        <button
                          type="button"
                          className="ncf-services-search-clear"
                          onClick={() => setServiceSearch('')}
                          aria-label="Effacer la recherche"
                        >
                          <CloseIcon />
                        </button>
                      )}
                    </div>

                    {/* Category chips with counts */}
                    <div className="ncf-services-categories">
                      {SERVICE_CATEGORIES.map((cat) => {
                        const count = cat.id === 'all'
                          ? SERVICES.length
                          : SERVICES.filter((s) => s.category === cat.id).length;

                        return (
                          <button
                            key={cat.id}
                            type="button"
                            data-cat={cat.id}
                            className={`ncf-cat-chip${activeCategory === cat.id ? ' ncf-cat-chip--active' : ''}`}
                            onClick={() => setActiveCategory(cat.id)}
                          >
                            {cat.icon && <span className="ncf-cat-chip-icon">{cat.icon}</span>}
                            {cat.label}
                            <span className="ncf-cat-count">{count}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Result line */}
                  <div className="ncf-services-result-line">
                    {services.length > 0
                      ? `${services.length} service${services.length > 1 ? 's' : ''} sélectionné${services.length > 1 ? 's' : ''}`
                      : 'Aucun service sélectionné'}
                  </div>

                  {/* Services grid */}
                  {filteredServices.length === 0 ? (
                    <p className="ncf-services-empty">Aucun service ne correspond à votre recherche.</p>
                  ) : (
                    <div className="ncf-services-grid">
                      {filteredServices.map((s) => (
                        <div
                          key={s.value}
                          className={`ncf-service-item${s.ramadan ? ' ncf-service-item--ramadan' : ''}`}
                        >
                          <input
                            type="checkbox"
                            id={`svc-${s.value}`}
                            value={s.value}
                            checked={services.includes(s.value)}
                            onChange={handleCheckboxChange}
                          />
                          <label className="ncf-service-label" htmlFor={`svc-${s.value}`}>
                            <span className="ncf-service-icon">{s.icon}</span>
                            <span className="ncf-service-text">{s.label}</span>
                            <span className="ncf-service-check" />
                          </label>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Custom services */}
                  {customServices.length > 0 && (
                    <>
                      <p className="ncf-add-service-title" style={{ marginTop: 28 }}>Services personnalisés</p>
                      <div className="ncf-services-grid">
                        {customServices.map((s) => (
                          <div key={s.value} className="ncf-service-item ncf-service-item--custom">
                            <input
                              type="checkbox"
                              id={`svc-${s.value}`}
                              value={s.value}
                              checked={services.includes(s.value)}
                              onChange={handleCheckboxChange}
                            />
                            <label className="ncf-service-label" htmlFor={`svc-${s.value}`}>
                              <span className="ncf-service-icon">{renderCustomIcon(s.icon)}</span>
                              <span className="ncf-service-text">{s.label}</span>
                              <button
                                type="button"
                                className="ncf-service-remove"
                                onClick={(e) => { e.preventDefault(); removeCustomService(s.value); }}
                                aria-label="Supprimer"
                              >
                                <CloseIcon />
                              </button>
                            </label>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Add custom service */}
                  <div className="ncf-add-service">
                    <p className="ncf-add-service-title">Ajouter un service personnalisé</p>
                    <div className="ncf-add-service-row">
                      <div className="ncf-emoji-wrap">
                        <button
                          type="button"
                          className="ncf-emoji-trigger"
                          onClick={() => setShowPicker((p) => !p)}
                          aria-expanded={showPicker}
                        >
                          {renderSelectedIcon()}
                          <span className="ncf-emoji-caret">▾</span>
                        </button>

                        {showPicker && (
                          <div className="ncf-emoji-picker">
                            <input
                              className="ncf-picker-search"
                              type="text"
                              placeholder="Rechercher une icône…"
                              value={iconSearch}
                              onChange={(e) => setIconSearch(e.target.value)}
                              autoFocus
                            />
                            <div className="ncf-mui-grid">
                              {filteredMuiIcons.map(([name, component]) => (
                                <button
                                  key={name}
                                  type="button"
                                  title={name}
                                  className={`ncf-mui-btn${newServiceIcon.value === name ? ' ncf-mui-btn--active' : ''}`}
                                  onClick={() => {
                                    setNewServiceIcon({ type: 'mui', value: name });
                                    setShowPicker(false);
                                  }}
                                >
                                  {component}
                                </button>
                              ))}
                              {filteredMuiIcons.length === 0 && (
                                <p className="ncf-picker-empty">Aucune icône trouvée</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <input
                        className="ncf-input ncf-add-service-input"
                        type="text"
                        placeholder="Nom du service (ex. Accès rooftop)"
                        value={newServiceLabel}
                        onChange={(e) => setNewServiceLabel(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), addCustomService())}
                      />

                      <button type="button" className="ncf-btn-add-service" onClick={addCustomService}>
                        + Ajouter
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ─── 07 · LISTING ───────────────────────────────────────────── */}
            <section className="ncf-section">
              <div className="ncf-section-head">
                <div className="ncf-section-meta">
                  <span className="ncf-section-num">07</span>
                  <h2 className="ncf-section-title">Listing Type</h2>
                  <p className="ncf-section-desc">Choose visibility level</p>
                </div>

                <div className="ncf-section-body">
                  <div className="ncf-listing-tabs">
                    <div
                      className={`ncf-listing-tab${!featured ? ' ncf-listing-tab--active' : ''}`}
                      onClick={() => setFeatured(false)}
                    >
                      <div className="ncf-tab-title">Standard</div>
                      <div className="ncf-tab-desc">Regular listing in search results</div>
                    </div>
                    <div
                      className={`ncf-listing-tab${featured ? ' ncf-listing-tab--active' : ''}`}
                      onClick={() => setFeatured(true)}
                    >
                      <div className="ncf-tab-title">Featured ✦</div>
                      <div className="ncf-tab-desc">Highlighted at the top of results</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ─── SUBMIT ─────────────────────────────────────────────────── */}
            <div className="ncf-submit-zone">
              <p className="ncf-submit-note">All fields marked are optional except name & city.</p>
              <button type="submit" className="ncf-btn-submit" onClick={handleClick}>
                <CheckCircleOutlineIcon />
                Create listing
                <ArrowForwardIcon />
              </button>
            </div>

          </form>
        </div>

        <footer className="ncf-footer">
          © {new Date().getFullYear()} <span>Moroccool</span> — All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default NewCafe;